export default __webpack_public_path__ + "static/media/photo.49ad583f.jpg";